import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, forwardRef } from 'react';
import { theme } from './theme.js';
import { css, inputReset, inputBase, inputFocusRing, inputErrorRing } from './styles.js';
export const Input = forwardRef(({ type = 'text', label, placeholder, value, onChange, error, disabled = false, required = false, helpText, icon, size = 'md', className, style, ...rest }, ref) => {
    const [isFocused, setIsFocused] = useState(false);
    const internalRef = useRef(null);
    // Size configurations
    const sizeStyles = {
        sm: {
            padding: `${theme.spacing.sm} ${theme.spacing.md}`,
            fontSize: theme.typography.fontSize.sm.size,
            height: '32px',
        },
        md: {
            padding: `${theme.spacing.md} ${theme.spacing.lg}`,
            fontSize: theme.typography.fontSize.base.size,
            height: '40px',
        },
        lg: {
            padding: `${theme.spacing.lg} ${theme.spacing.xl}`,
            fontSize: theme.typography.fontSize.lg.size,
            height: '48px',
        },
    };
    const sizeConfig = sizeStyles[size];
    const inputStyle = css(inputReset(), inputBase(), {
        ...sizeConfig,
        border: `1.5px solid ${isFocused ? 'var(--k-brand)' : error ? 'var(--k-danger)' : 'var(--k-border)'}`,
        fontFamily: theme.typography.fontFamily.primary,
        fontWeight: theme.typography.fontWeight.normal,
    }, disabled
        ? {
            opacity: 0.6,
            cursor: 'not-allowed',
            backgroundColor: 'var(--k-bg-elevated)',
        }
        : undefined, isFocused ? inputFocusRing() : undefined, !isFocused && error ? inputErrorRing() : undefined, style);
    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing.xs,
    };
    const labelStyle = {
        fontSize: theme.typography.fontSize.sm.size,
        fontWeight: theme.typography.fontWeight.medium,
        color: 'var(--k-text-primary)',
        margin: 0,
    };
    const inputWrapperStyle = {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
    };
    const iconStyle = {
        position: 'absolute',
        left: theme.spacing.lg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        color: 'var(--k-text-secondary)',
    };
    const errorStyle = {
        fontSize: theme.typography.fontSize.xs.size,
        color: 'var(--k-danger)',
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginTop: theme.spacing.xs,
    };
    const helpStyle = {
        fontSize: theme.typography.fontSize.xs.size,
        color: 'var(--k-text-secondary)',
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginTop: theme.spacing.xs,
    };
    const actualInputStyle = icon
        ? css(inputStyle, {
            paddingLeft: `calc(${theme.spacing.lg} + ${theme.spacing.xl} + ${theme.spacing.md})`,
        })
        : inputStyle;
    return (_jsxs("div", { style: containerStyle, className: className, children: [label && (_jsxs("label", { style: labelStyle, children: [label, required && (_jsx("span", { style: { color: 'var(--k-danger)', marginLeft: theme.spacing.xs }, children: "*" }))] })), _jsxs("div", { style: inputWrapperStyle, children: [icon && _jsx("div", { style: iconStyle, children: icon }), _jsx("input", { ref: ref || internalRef, type: type, placeholder: placeholder, value: value, onChange: (e) => onChange?.(e.target.value), disabled: disabled, onFocus: () => setIsFocused(true), onBlur: () => setIsFocused(false), style: actualInputStyle, className: "k-focus-ring", "aria-invalid": !!error, "aria-describedby": error ? `${rest.name}-error` : helpText ? `${rest.name}-help` : undefined, ...rest })] }), error && (_jsx("p", { id: `${rest.name}-error`, style: errorStyle, role: "alert", children: error })), helpText && !error && (_jsx("p", { id: `${rest.name}-help`, style: helpStyle, children: helpText }))] }));
});
Input.displayName = 'Input';
//# sourceMappingURL=Input.js.map